import api from './_client';
import testsApi from "./tests";

export default {
    getTest(hash) {
        return api.get('test/' + hash);
    },
    store(data) {
        return api.post('test', data);
    },
    getVerificationCode(data) {
        return api.post('test/get-code', data);
    },
    createTester(data) {
        return api.post('test/tester', data);
    }
}
